/** Adapted from standalone-search f83fe2d1 via selected Registrar V2. See docs/delivery/iteration2/fusion-shared-kit/TRANSFER.json. */
import type { Table } from "@tanstack/react-table";
import { ChevronsLeft as FastArrowLeft, ChevronsRight as FastArrowRight, ChevronLeft as NavArrowLeft, ChevronRight as NavArrowRight } from "lucide-react";

import { Button } from "@/components/ui/button";


interface DataTablePaginationProps<TData> {
  table: Table<TData>;
}

export function DataTablePagination<TData>({
  table,
}: DataTablePaginationProps<TData>) {
  const empty = table.getFilteredRowModel().rows.length === 0;
  return (
    <div className="flex items-center justify-between px-4">
      <div className="flex w-full items-center gap-8 lg:w-fit">
        <div className="flex w-fit items-center justify-center text-ui font-medium">
          {empty ? "No results" : <>Page {table.getState().pagination.pageIndex + 1} of{" "}{table.getPageCount()}</>}
        </div>
        <div className="ml-auto flex items-center gap-2 lg:ml-0">
          <Button
            variant="outline"
            className="hidden size-[var(--control-height-compact)] p-0 lg:flex"
            onClick={() => table.setPageIndex(0)}
            disabled={empty || !table.getCanPreviousPage()}
          >
            <span className="sr-only">Go to first page</span>
            <FastArrowLeft />
          </Button>
          <Button
            variant="outline"
            className="size-[var(--control-height-compact)]"
            size="icon"
            onClick={() => table.previousPage()}
            disabled={empty || !table.getCanPreviousPage()}
          >
            <span className="sr-only">Previous</span>
            <NavArrowLeft />
          </Button>
          <Button
            variant="outline"
            className="size-[var(--control-height-compact)]"
            size="icon"
            onClick={() => table.nextPage()}
            disabled={empty || !table.getCanNextPage()}
          >
            <span className="sr-only">Next</span>
            <NavArrowRight />
          </Button>
          <Button
            variant="outline"
            className="hidden size-[var(--control-height-compact)] lg:flex"
            size="icon"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={empty || !table.getCanNextPage()}
          >
            <span className="sr-only">Go to last page</span>
            <FastArrowRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
